import { keyframes } from "@emotion/react"
import { Box, CircularProgress, Container, Typography } from "@mui/material"
import { t } from "i18next"
import { FC } from "react"

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const LoadingPage: FC = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mt: 4,
          mb: 2,
        }}
      >
        <CircularProgress
          size={60}
          sx={{
            animation: `${spin} 2s linear infinite`,
          }}
        />
      </Box>
      <Typography variant="h5" component="div" gutterBottom>
        {`${t("loading")}...`}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t("waitWhileLoading")}
      </Typography>
    </Container>
  )
}

export default LoadingPage
